<template>
  <div>
    <Header />
    <div style="padding-left: 30px; padding-right: 30px; padding-bottom: 80px">
      <br />
      <el-alert
        show-icon
        :closable="false"
        title="FELICIDADES SU CUENTA DE USUARIO FUE CREADA EXITOSAMENTE!"
        type="success"
      >
      </el-alert>
      <br />
      <b
        ><small
          >A continuación se detallará la información de su cuenta de
          usuario</small
        ></b
      >
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :sm="24">
          <br />
          <b><span style="font-size: 18px">DATOS DEL USUARIO</span></b>
          <hr />
          <br />
        </el-col>
        <el-col :sm="6">
          <b><span style="color: #f67b2f">Nombre</span></b>
          <br /><br />
          {{ $route.params.user.nombre }}
        </el-col>
        <el-col :sm="6">
          <b><span style="color: #f67b2f">Apellido</span></b>
          <br /><br />
          {{ $route.params.user.apellido }}
        </el-col>
        <el-col :sm="6">
          <b><span style="color: #f67b2f">RUT</span></b>
          <br /><br />
          {{ $route.params.user.rut }}
        </el-col>
        <el-col :sm="6">
          <b><span style="color: #f67b2f">Email</span></b>
          <br /><br />
          {{ $route.params.user.email }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24">
          <br />
          <br />
          <b><span style="font-size: 18px">RESUMEN DE SUS ROLES</span></b>
          <hr />
          <br />
        </el-col>
        <el-col :sm="24">
          <el-row :gutter="20">
            <el-col :sm="8" v-if="$route.params.mis_roles_mel.length > 0">
              <div style="width: 100%">
                <b
                  ><span style="color: rgb(246, 123, 47)"
                    >MINERA ESCONDIDA</span
                  ></b
                >
                <br /><br />
                <div v-if="getPropios($route.params.mis_roles_mel).length > 0">
                  <b><span style="font-size: 13px">ROLES EN ÁREAS</span></b>
                  <div
                    v-for="(item, index) in getPropios(
                      $route.params.mis_roles_mel
                    )"
                    :key="index"
                  >
                    <ul>
                      <li>{{ item.area_name }}</li>
                      <ul style="margin-top: 5px">
                        <li v-for="(rol, index) in item.roles" :key="index">
                          {{ bhpProfiles[rol] }}
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
                <div
                  v-if="getContratistas($route.params.mis_roles_mel).length > 0"
                >
                  <b><span style="font-size: 13px">ROLES EN EMPRESAS</span></b>
                  <div
                    v-for="(item, index) in getContratistas(
                      $route.params.mis_roles_mel
                    )"
                    :key="index"
                  >
                    <ul>
                      <li>{{ item.empresa_name }}</li>
                      <ul style="margin-top: 5px">
                        <li
                          style="margin-top: 5px"
                          v-for="(rol, index) in item.roles"
                          :key="index"
                        >
                          {{ bhpProfiles[rol] }}
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :sm="8" v-if="$route.params.mis_roles_spence.length > 0">
              <div style="width: 100%">
                <b
                  ><span style="color: rgb(246, 123, 47)"
                    >MINERA SPENCE</span
                  ></b
                >
                <br /><br />
                <div
                  v-if="getPropios($route.params.mis_roles_spence).length > 0"
                >
                  <b><span style="font-size: 13px">ROLES EN ÁREAS</span></b>
                  <div
                    v-for="(item, index) in getPropios(
                      $route.params.mis_roles_spence
                    )"
                    :key="index"
                  >
                    <ul>
                      <li>{{ item.area_name }}</li>
                      <ul style="margin-top: 5px">
                        <li
                          style="margin-top: 5px"
                          v-for="(rol, index) in item.roles"
                          :key="index"
                        >
                          {{ bhpProfiles[rol] }}
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
                <div
                  v-if="
                    getContratistas($route.params.mis_roles_spence).length > 0
                  "
                >
                  <b><span style="font-size: 13px">ROLES EN EMPRESAS</span></b>
                  <div
                    v-for="(item, index) in getContratistas(
                      $route.params.mis_roles_spence
                    )"
                    :key="index"
                  >
                    <ul>
                      <li>{{ item.empresa_name }}</li>
                      <ul style="margin-top: 5px">
                        <li
                          style="margin-top: 5px"
                          v-for="(rol, index) in item.roles"
                          :key="index"
                        >
                          {{ bhpProfiles[rol] }}
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :sm="8" v-if="$route.params.mis_roles_cerro.length > 0">
              <div style="width: 100%">
                <b
                  ><span style="color: rgb(246, 123, 47)"
                    >MNERA CERRO COLORADO</span
                  ></b
                >
                <br /><br />
                <div
                  v-if="getPropios($route.params.mis_roles_cerro).length > 0"
                >
                  <b><span style="font-size: 13px">ROLES EN ÁREAS</span></b>
                  <div
                    v-for="(item, index) in getPropios(
                      $route.params.mis_roles_cerro
                    )"
                    :key="index"
                  >
                    <ul>
                      <li>{{ item.area_name }}</li>
                      <ul style="margin-top: 5px">
                        <li v-for="(rol, index) in item.roles" :key="index">
                          {{ bhpProfiles[rol] }}
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
                <div
                  v-if="
                    getContratistas($route.params.mis_roles_cerro).length > 0
                  "
                >
                  <b><span style="font-size: 13px">ROLES EN EMPRESAS</span></b>
                  <div
                    v-for="(item, index) in getContratistas(
                      $route.params.mis_roles_cerro
                    )"
                    :key="index"
                  >
                    <ul>
                      <li>{{ item.empresa_name }}</li>
                      <ul style="margin-top: 5px">
                        <li v-for="(rol, index) in item.roles" :key="index">
                          {{ bhpProfiles[rol] }}
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <br /><br />
      <el-alert show-icon title="Información" type="info">
        <template>
          <br />
          <div style="margin-top: 15px; color: black">
            ¿Necesitas crear un contrato para cargar tu inventario?, puedes
            continuar creándolo haciendo clic en el siguiente botón <br />
            <el-button
              @click="createContract"
              type="primary"
              size="small"
              style="margin-top: 15px"
              icon="el-icon-plus"
              >Crear contrato</el-button
            >
          </div>
        </template>
      </el-alert>
      <br />
      <br />
      <center>
        <el-button type="primary" @click="backStep()" icon="el-icon-arrow-left"
          >Regresar a la página principal</el-button
        >
      </center>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

export default {
  data() {
    return {
      bhpProfiles: {
        hse: "HSE",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        owner: "Dueño de Contrato",
        contract_owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        administrator: "Administrador de Contrato",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
        superadmin: "Administrador del sistema",
      },
    };
  },
  components: {
    Header,
  },
  methods: {
    createContract() {
      this.$router.push({ name: "buscarContrato" });
    },
    getContratistas(item) {
      var retorno = item.filter(function (el) {
        return el.tipo === "contratista";
      });
      return retorno;
    },
    getPropios(item) {
      var retorno = item.filter(function (el) {
        return el.tipo === "propio";
      });
      return retorno;
    },
    backStep() {
      this.$router.push("/");
    },
  },
};
</script>